import React from 'react';
import { Database } from 'lucide-react';
import { EEmpty } from 'libs/ui';

export const EmptyState: React.FC = () => {
    return (
        <div className="flex items-center justify-center h-full">
            <EEmpty
                icon={<Database size={56} className="text-gray-400" />}
                title="No external API logs found"
                description="No API calls were made for this booking"
            />
        </div>
    );
};
